/** 能源 — 用电流向桑基图 /energy/electricity-sankey（electricitySankey.vue） */
export default {
  electricitySankey: {
    filterQueryDate: '查询日期',
    phPickDate: '选择日期',
    filterTenantScope: '租户范围',
    phTenant: '请选择租户',
    btnQuery: '查询',
    btnReset: '重置',
    btnSelectAll: '全选',
    btnDeselectAll: '取消全选',
    moreActions: '更多操作',
    exportChart: '导出图表',
    exportData: '导出数据',
    cardTotalElec: '总用电量',
    cardTotalElecTip: '所有租户当日总用电量',
    vsYesterday: '较昨日',
    cardTenantCount: '租户数量',
    unitTenants: '户',
    activeTenants: '活跃租户',
    cardAvgElec: '平均用电',
    unitKwhPerTenant: 'kWh/户',
    dailyPerTenant: '单户日均',
    cardDistribution: '用电分布',
    byTypeDistribution: '按类型分布',
    distBarTitle: '{name}: {value} kWh ({pct}%)',
    loading: '数据加载中...',
    chartTitle: '用电流向分析',
    chartSubtitle: '{date} 租户用电分布桑基图',
    tipDragChart: '提示：可使用鼠标拖拽移动图表',
    viewSankey: '桑基图',
    viewTree: '树状图',
    pickerYesterday: '昨天',
    pickerDayBefore: '前天',
    pickerMondayThisWeek: '本周一',
    msgTenantListFail: '获取租户列表失败',
    msgPickDate: '请选择查询日期',
    msgPickTenant: '请选择租户',
    msgFetchFail: '获取数据失败',
    msgExportDeveloping: '数据导出功能开发中',
    tooltipElecLine: '用电量：{value} kWh',
    tooltipFlowLine: '{from} → {to}',
    toolboxRestore: '还原',
    toolboxSaveImage: '保存为图片',
    exportPngName: '用电桑基图_{date}.png',
    nodePrivate: '专用设备',
    nodeShare: '公摊设备',
    defaultTotalName: '园区总用电',
    shareDeviceTitle: '{name}（分摊）',
    abbrTenThousand: '万',
    abbrThousand: '千'
  }
}
